// extracted by mini-css-extract-plugin
export default {"root":"style-module__root____V5Vp","root__wrapper":"style-module__root__wrapper___UQ430","root__wrapper_label":"style-module__root__wrapper_label___cJSOg","root__wrapper_text":"style-module__root__wrapper_text___ifR0z","root__actions":"style-module__root__actions___nFz0S","root__actions_btn":"style-module__root__actions_btn___JlAfk"};
    if(module.hot) {
      // 1744730410578
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  